import axios from "axios";
import { BASE_URL } from "../constants";

/**
 * Fetch Expert Requests (paginated)
 * @param {number} page - page number
 * @param {number} limit - results per page (optional)
 * @param {string} search - search term (optional)
 * @returns {Promise<Object>} - API response
 */
export const fetchExpertRequests = async (page = 1, limit = 10, search = "") => {
  try {
    const response = await axios.get(
      `${BASE_URL}api/experts/expert-requests`,
      {
        params: { page, limit, search },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching expert requests:", error);
    throw error;
  }
};

export const deleteExpertRequest = async (id) => {
  try {
    const res = await axios.delete(`${BASE_URL}api/experts/expert-requests/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting expert request:", error);
    throw error;
  }
};

export const convertExpertRequestToWarm = async (id) => {
  try {
    const res = await axios.post(`${BASE_URL}api/experts/expert-requests/${id}/convert`);
    return res.data;
  } catch (error) {
    console.error("Error converting expert request:", error);
    throw error;
  }
};

export const deleteContactQuery = async (id) => {
  try {
    const res = await axios.delete(`${BASE_URL}api/experts/contacts/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting contact query:", error);
    throw error;
  }
};


/**
 * Fetch Contact Queries (paginated)
 */
export const fetchContactQueries = async (page = 1, limit = 10, search = "", type = "") => {
  try {
    const response = await axios.get(`${BASE_URL}api/experts/contacts`, {
      params: { page, limit, search, type },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching contact queries:", error);
    throw error;
  }
};
